export default function CustomerStyle(){
    const customStyles = {
        table: {
            style: {
              width: "100%", // Largeur du tableau
              height: "500px", // Hauteur du tableau
            },
          },
        headRow: {
            style: {
                backgroundColor: 'blue',
                color: 'white'
            }
        },
        headCells: {
            style: {
                fontSize: '10px',
                fontWeight: '600',
                textTransform: 'uppercase'
            }
        },
        cells: {
            style: {
              fontSize: "10px", // Texte plus grand
              padding: "10px", // Plus d'espace dans les cellules
            },
          },
    };

    return customStyles;
}